import { _APP_CONFIG } from "../../core/config/AppConfig";
import { DataDRequest } from "../DRequest";
import {
    ICatalogoSATClaveProductServ, ICatalogoSATClaveUnidad, ICatalogoSATFormaPago,
    ICatalogoSATImpuesto, ICatalogoSATMetodoPago, ICatalogoSATPais,
    ICatalogoSATRegimenFiscal, IUsoCFDI
} from "../entidad/Factura";

/** TipoCFDI */
export function _SvFacturaObtenerTiposDocumentos(/* idEscuela: number */) {
    return [
        { key: "factura", name: "Factura" },
        // { key: "factura_hotel", name: "Factura para hoteles" },
        // { key: "honorarios", name: "Recibo de honorarios" },
        // { key: "nota_cargo", name: "Nota de cargo" },
        // { key: "donativos", name: "Donativo" },
        // { key: "arrendamiento", name: "Recibo de arrendamiento" },
        // { key: "nota_credito", name: "Nota de crédito" },
        // { key: "nota_debito", name: "Nota de débito" },
        // { key: "nota_devolucion", name: "Nota de devolución" },
        // { key: "carta_porte", name: "Carta porte" },
        // { key: "carta_porte_ingreso", name: "Carta porte de Ingreso" },
        // { key: "pago", name: "Pago" },
        // { key: "retencion", name: "Retención" },
    ]
}

const REQUEST_MANAGER: { [k: string]: { [x: number]: Promise<DataDRequest.IRequestResponseA<any>> } } = {}
function ManageRequest<T>(url: string, idEscuela: number, params: Object): Promise<DataDRequest.IRequestResponseA<T[]>> {
    if (!REQUEST_MANAGER[url])
        REQUEST_MANAGER[url] = {}
    if (REQUEST_MANAGER[url][idEscuela]) {
        return REQUEST_MANAGER[url][idEscuela]
    }
    const res = DataDRequest._Request5<T[]>(url, "GET", params)
        .then(res => {
            if (res.Resultado <= 0) {
                REQUEST_MANAGER[url][idEscuela] = null
            }
            return res
        })
    REQUEST_MANAGER[url][idEscuela] = res
    return res
}

export function _SvFacturaObtenerCatalogoSATRegimenFiscal(idEscuela: number) {
    const url = _APP_CONFIG.URL_RSTV2 + "factura/ObtenerCatalogoSATRegimenFiscal"
    const params = {
        "IdEscuela": idEscuela,
    }
    return ManageRequest<ICatalogoSATRegimenFiscal>(url, idEscuela, params)
}

export function _SvFacturaObtenerCatalogoSATPais(idEscuela: number) {
    const url = _APP_CONFIG.URL_RSTV2 + "factura/ObtenerCatalogoSATPais"
    const params = {
        "IdEscuela": idEscuela,
    }
    return ManageRequest<ICatalogoSATPais>(url, idEscuela, params)
}

export function _SvFacturaObtenerCatalogoSATUsoCFDI(idEscuela: number) {
    const url = _APP_CONFIG.URL_RSTV2 + "factura/ObtenerCatalogoSATUsoCFDI"
    const params = {
        "IdEscuela": idEscuela,
    }
    return ManageRequest<IUsoCFDI>(url, idEscuela, params)
}

export function _SvFacturaObtenerCatalogoSATFormaPago(idEscuela: number) {
    const url = _APP_CONFIG.URL_RSTV2 + "factura/ObtenerCatalogoSATFormaPago"
    const params = {
        "IdEscuela": idEscuela,
    }
    return ManageRequest<ICatalogoSATFormaPago>(url, idEscuela, params)
}

export function _SvFacturaObtenerCatalogoSATMetodoPago(idEscuela: number) {
    const url = _APP_CONFIG.URL_RSTV2 + "factura/ObtenerCatalogoSATMetodoPago"
    const params = {
        "IdEscuela": idEscuela,
    }
    return ManageRequest<ICatalogoSATMetodoPago>(url, idEscuela, params)
}

export function _SvFacturaObtenerCatalogoSATImpuesto(idEscuela: number) {
    const url = _APP_CONFIG.URL_RSTV2 + "factura/ObtenerCatalogoSATImpuesto"
    const params = {
        "IdEscuela": idEscuela,
    }
    return ManageRequest<ICatalogoSATImpuesto>(url, idEscuela, params)
}

export function _SvFacturaObtenerCatalogoSATClaveUnidad(idEscuela: number) {
    const url = _APP_CONFIG.URL_RSTV2 + "factura/ObtenerCatalogoSATClaveUnidad"
    const params = {
        "IdEscuela": idEscuela,
    }
    return ManageRequest<ICatalogoSATClaveUnidad>(url, idEscuela, params)
        .then(res => {
            if (res.Datos) res.Datos.forEach(d => {
                d.key = d.key.toString()
            })
            return res
        })
}

export function _SvFacturaObtenerCatalogoSATClaveProductServ(idEscuela: number) {
    const url = _APP_CONFIG.URL_RSTV2 + "factura/ObtenerCatalogoSATClaveProductServ"
    const params = {
        "IdEscuela": idEscuela,
    }
    return ManageRequest<ICatalogoSATClaveProductServ>(url, idEscuela, params)
}